import React from 'react';
import { Outlet } from 'react-router-dom';
import { PublicDonateProvider } from '../../contexts/PublicDonateContext';
import PortalChrome from '../../components/portal/PortalChrome';

export default function PublicDonateLayout() {
  return (
    <PublicDonateProvider>
      <PortalChrome>
        <Outlet />
      </PortalChrome>
    </PublicDonateProvider>
  );
}
